var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9844 26.0781C43.2656 34.6719 36.786 42.7637 27.6938 44.5719C23.2594 45.455 18.6594 44.9165 14.5488 43.0332C10.4382 41.1499 7.02655 38.0177 4.79965 34.0826C2.57275 30.1476 1.6441 25.6102 2.14595 21.1167C2.6478 16.6231 4.55454 12.4024 7.5947 9.0556C13.8303 2.18747 24.3594 0.296849 32.9531 3.73435",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7613 13.975C21.7298 13.6622 21.7644 13.3462 21.8626 13.0475C21.9608 12.7488 22.1205 12.474 22.3315 12.2409C22.5424 12.0077 22.7999 11.8213 23.0872 11.6938C23.3746 11.5662 23.6856 11.5003 24 11.5003C24.3144 11.5003 24.6254 11.5662 24.9128 11.6938C25.2001 11.8213 25.4576 12.0077 25.6686 12.2409C25.8795 12.474 26.0392 12.7488 26.1374 13.0475C26.2356 13.3462 26.2702 13.6622 26.2387 13.975L25.3658 28.2625C25.332 28.6013 25.1736 28.9155 24.9212 29.144C24.6688 29.3725 24.3405 29.4991 24 29.4991C23.6595 29.4991 23.3312 29.3725 23.0788 29.144C22.8264 28.9155 22.668 28.6013 22.6343 28.2625L21.7613 13.975ZM21.75 34C21.75 33.4033 21.9871 32.831 22.409 32.409C22.831 31.9871 23.4033 31.75 24 31.75C24.5967 31.75 25.169 31.9871 25.591 32.409C26.0129 32.831 26.25 33.4033 26.25 34C26.25 34.5968 26.0129 35.1691 25.591 35.591C25.169 36.013 24.5967 36.25 24 36.25C23.4033 36.25 22.831 36.013 22.409 35.591C21.9871 35.1691 21.75 34.5968 21.75 34Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.881fc574a478a93a52a395a701beea76.svg";
export { ForwardRef as ReactComponent };